var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 133",
    d: "M27.207.386A1.227 1.227 0 0 0 26.329 0H6.634A6.63 6.63 0 0 0 0 6.558v36.884A6.63 6.63 0 0 0 6.634 50h26.732A6.63 6.63 0 0 0 40 43.442V14.154a1.293 1.293 0 0 0-.354-.845Zm.354 3.877 8.329 8.659h-5.414a2.89 2.89 0 0 1-2.915-2.874Zm5.8 43.321H6.634a4.2 4.2 0 0 1-4.2-4.143V6.558a4.2 4.2 0 0 1 4.2-4.142h18.488v7.633a5.31 5.31 0 0 0 5.354 5.29h7.085v28.1a4.2 4.2 0 0 1-4.195 4.146Zm0 0",
    fill: "#26890d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "view (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M31.801 26.535c-.214-.292-5.3-7.153-11.8-7.153S8.412 26.247 8.199 26.535a.789.789 0 0 0 0 .93c.213.292 5.3 7.153 11.8 7.153s11.588-6.861 11.8-7.153a.788.788 0 0 0 .002-.93Zm-11.8 6.507c-4.787 0-8.933-4.554-10.161-6.043 1.226-1.49 5.363-6.042 10.161-6.042S28.934 25.51 30.162 27c-1.227 1.491-5.365 6.047-10.162 6.047Z",
    fill: "#26890d"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M20 22.272a4.729 4.729 0 1 0 4.729 4.729A4.734 4.734 0 0 0 20 22.272Zm0 7.881a3.152 3.152 0 1 1 3.152-3.152A3.156 3.156 0 0 1 20 30.153Z",
    fill: "#26890d"
  }))))));
};
export default SvgView;